import React from "react";
import PropTypes from "prop-types";

const YoutubeVideo = ({ embedId, _style }) => (
  <div className="youtube-video" style={embedId != "" ? _style: {position:"absolute", width: "0%"}}>
    <iframe
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${embedId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
    />
  </div>
);

YoutubeVideo.propTypes = {
  embedId: PropTypes.string.isRequired,
  _style: PropTypes.isRequired
};

export default YoutubeVideo;